module.exports = __webpack_public_path__ + "static/Accessible_Team_Insights-82eae9fbb4af24c8d8700046d2293d23.png";